import React from "react";
import ReactDOM from "react-dom";
import VodList from "../components/vod/VodList";
import { initializeI18n } from '../localization/i18n';

window.renderVOD = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {

        initializeI18n()
            .then((i18nInstance) => {
                ReactDOM.render(<VodList />, element);
            })
            .catch(error => {
                //console.error("Failed to initialize i18n before rendering Vod:", error);
            });

    } else {
        //console.error(`Element with ID ${elementId} not found.`);
    }
};
